enum ResidualMode {
  PERCENT = 'PERCENT',
  AMOUNT = 'AMOUNT',
}

export default ResidualMode
